module.exports = __webpack_public_path__ + "img/bubble.f7250ca7.svg";